import styled from 'styled-components'

interface IActProps {
  size?: 'normal' | 'small'
  uppercase?: boolean
  narrow?: boolean
}

export const ACT = styled.button<IActProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 110px;
  ${({ size }) => (size === 'small' ? 'padding: 18px 110px;' : '')}
  ${({ narrow }) => (narrow ? 'padding-left: 18px;padding-right: 18px;' : '')}
  ${({ uppercase }) => (uppercase ? 'text-transform: uppercase;' : '')}
  border: 2px solid #ffffff;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 16px;
  line-height: 29px;
  background-color: transparent;
  color: #ffffff;
  cursor: pointer;

  &:hover {
    background-color: #ffffff;
    color: #000;
  }
`
